class EpicurioMegaMenu extends HTMLElement {
  connectedCallback() {
    this.triggers = Array.from(this.querySelectorAll('[data-epicurio-preview-trigger]'));
    this.panels = Array.from(this.querySelectorAll('[data-epicurio-preview-panel]'));

    this.handlePointerOver = this.handlePointerOver.bind(this);
    this.handleFocusIn = this.handleFocusIn.bind(this);

    this.addEventListener('pointerover', this.handlePointerOver);
    this.addEventListener('focusin', this.handleFocusIn);
  }

  disconnectedCallback() {
    this.removeEventListener('pointerover', this.handlePointerOver);
    this.removeEventListener('focusin', this.handleFocusIn);
  }

  handlePointerOver(event) {
    const trigger = event.target.closest('[data-epicurio-preview-trigger]');
    if (trigger && this.contains(trigger)) this.activate(trigger);
  }

  handleFocusIn(event) {
    const trigger = event.target.closest('[data-epicurio-preview-trigger]');
    if (trigger && this.contains(trigger)) this.activate(trigger);
  }

  activate(trigger) {
    const panelId = trigger.dataset.epicurioPreviewTrigger;
    if (!panelId) return;

    this.triggers.forEach((item) => {
      const active = item === trigger;
      item.classList.toggle('is-active', active);
      if (active) item.setAttribute('aria-current', 'true');
      else item.removeAttribute('aria-current');
    });

    this.panels.forEach((panel) => {
      const active = panel.dataset.epicurioPreviewPanel === panelId;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });
  }
}

if (!customElements.get('epicurio-mega-menu')) {
  customElements.define('epicurio-mega-menu', EpicurioMegaMenu);
}
